import type { Benchmark } from '../../api';
import { formatAmount } from '../../format';
import type { DetailField } from '../../ui/detailForm';

/**
 * A benchmark in the detail popup (AP-128): every field the catalogue
 * keeps. What the server lets the administration change is editable; the
 * note stays read-only - it carries the BKI position the long text hangs on.
 */
export function benchmarkFields(b: Benchmark): DetailField[] {
  const amount = (key: 'low' | 'mid' | 'high', label: string): DetailField => ({ key, label, value: b[key] === null ? null : formatAmount(b[key]), raw: b[key], edit: 'amount' });
  return [
    { key: 'costGroup', label: 'Kostengruppe', value: b.costGroup, mono: true, edit: 'text' },
    { key: 'label', label: 'Bezeichnung', value: b.label, edit: 'text', required: true },
    { key: 'buildingType', label: 'Gebäudeart', value: b.buildingType, edit: 'text' },
    { key: 'unit', label: 'Einheit', value: b.unit, edit: 'text' },
    amount('low', 'von'),
    amount('mid', 'Mittel'),
    amount('high', 'bis'),
    { key: 'source', label: 'Quelle', value: b.source, edit: 'text', required: true },
    { key: 'edition', label: 'Ausgabe/Jahr', value: b.edition, edit: 'text' },
    { key: 'priceDate', label: 'Preisstand', value: b.priceDate, edit: 'text' },
    { key: 'region', label: 'Region', value: b.region, edit: 'text' },
    { key: 'license', label: 'Lizenzkennzeichnung', value: b.license, edit: 'text' },
    { key: 'duration', label: 'Ausführungsdauer', value: b.duration },
    { key: 'note', label: 'Bemerkung', value: b.note, long: true },
    { key: 'description', label: 'Beschreibung', value: b.description, long: true },
  ];
}
